import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { withRights } from '../../../../providers/RightsConsumer';

// material-ui components
import { TableCell, TableRow } from '@mui/material';
import { IconButton, TextField, Autocomplete } from '@totalsoft/rocket-ui';
import CancelIcon from '@mui/icons-material/Cancel';

class OfferDecisionConditionRowComponent extends React.PureComponent {
  handleConditionChange = decisionConditionId => {
    this.props.onPropertyChange('decisionConditionId', decisionConditionId);
  };

  handleCommentChange = value => {
    this.props.onPropertyChange('comment', value);
  };

  render() {
    const { condition, remainingConditions, rights, validationInfo, onRemoveItem } = this.props;
    return (
      <React.Fragment>
        <TableRow>
          <TableCell>
            {condition.isEditable ? (
              <Autocomplete
                fullWidth
                required
                labelKey='composedCode'
                valueKey='decisionConditionId'
                value={condition.decisionConditionId || ''}
                isSearchable={false}
                simpleValue={true}
                isClearable={false}
                onChange={this.handleConditionChange}
                options={
                  condition.decisionConditionId
                    ? [{ decisionConditionId: condition.decisionConditionId, composedCode: condition.composedCode }, ...remainingConditions]
                    : remainingConditions
                }
                error={validationInfo && validationInfo.decisionConditionId ? true : false}
                disabled={rights.readOnlyFull || !rights.decisionConditionsWrite}
              />
            ) : (
              condition.composedCode
            )}
          </TableCell>
          <TableCell>{condition.user}</TableCell>
          <TableCell>
            {condition.isEditable ? (
              <TextField
                name={'comment'}
                fullWidth
                value={condition.comment || ''}
                onChange={this.handleCommentChange}
                disabled={rights.readOnlyFull || !rights.decisionConditionsWrite}
              />
            ) : (
              <paragraph>{condition.comment}</paragraph>
            )}
          </TableCell>
          <TableCell colSpan={1} align='right'>
            <IconButton color='secondary' onClick={onRemoveItem} disabled={rights.readOnlyFull || !rights.decisionConditionsWrite}>
              <CancelIcon />
            </IconButton>
          </TableCell>
        </TableRow>
      </React.Fragment>
    );
  }
}

OfferDecisionConditionRowComponent.propTypes = {
  onRemoveItem: PropTypes.func.isRequired,
  onPropertyChange: PropTypes.func.isRequired,
  condition: PropTypes.object.isRequired,
  remainingConditions: PropTypes.array.isRequired,
  validationInfo: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
  rights: PropTypes.object.isRequired
};

export default withTranslation()(withRights(OfferDecisionConditionRowComponent));
